import { Component } from '@angular/core';

@Component({
  selector: 'mprd-tv-available-options-skeleton',
  templateUrl: './tv-available-options-skeleton.component.html',
  styleUrls: ['./tv-available-options-skeleton.component.css'],
})
export class TvAvailableOptionsSkeletonComponent {
  constructor() {}
}
